import {
  SuggestionCard,
  SuggestionCardSkeleton,
} from "@arcadeai/design-system/components/ui/molecules/suggestion-card";
import { ChatTemplateSuggestions } from "@arcadeai/design-system/components/ui/templates/chat-template";
import { cn } from "@arcadeai/design-system/lib/utils";
import type { SuggestedAction } from "../default-suggested-actions";

export type ChatSuggestionsProps = {
  actions: SuggestedAction[];
  onSelect: (action: SuggestedAction) => void;
  isLoading?: boolean;
};

export function ChatSuggestions({
  actions,
  onSelect,
  isLoading = false,
}: ChatSuggestionsProps) {
  if (actions.length === 0) {
    return null;
  }

  return (
    <ChatTemplateSuggestions>
      {actions.map((action, index) => (
        <div
          className={cn(
            "col-span-12 sm:col-span-6",
            index < 3 ? "md:col-span-4" : "md:col-span-6",
            index > 1 && "hidden sm:block"
          )}
          key={action.id}
        >
          {isLoading ? (
            <SuggestionCardSkeleton />
          ) : (
            <SuggestionCard
              icon={action.icon}
              onClick={() => onSelect(action)}
              subtitle={action.subtitle}
              title={action.title}
            />
          )}
        </div>
      ))}
    </ChatTemplateSuggestions>
  );
}
